import { customerInformationTemplate } from '@/api/index'

export function IsExistFile (data: any) {
  return customerInformationTemplate.request({
    method: 'post',
    url: '/IsExistFile',
    data
  })
}
export function CustomerInformationTemplateDelete (data: any) {
  return customerInformationTemplate.request({
    method: 'post',
    url: '/CustomerInformationTemplateDelete',
    data
  })
}
export function templateSavePGSData (data: any) {
  return customerInformationTemplate.request({
    method: 'post',
    url: '/SavePGSData',
    data
  })
}
export function templateGetPageGridBond (data: any) {
  return customerInformationTemplate.request({
    method: 'post',
    url: '/GetPageGridBond',
    data
  })
}
